import React from 'react';
import ProductsCards from 'components/ProductsCards';
import styled from 'styled-components/macro';
import { mediaQuery } from '@deeptrue-frontend/ui';
import brandingIcon from '../../assets/icons/branding/branding-color.svg';
import innovationIcon from '../../assets/icons/innovation/innovation-color.svg';
import experienceIcon from '../../assets/icons/experience/experience-color.svg';

const WorkbenchDetailStyled = styled.div`
  max-width: 100%;
  width: 100%;
  border-bottom: 1px solid #e6e6e5;
  margin-bottom: 2.5rem;
  padding-bottom: 1rem;

  &:last-child {
    border-bottom: 0 solid;
  }

  ${mediaQuery.md`
    display: grid;
    grid-template-columns: 268px 1fr;
    align-items: flex-start;
    column-gap: 2rem;
  `}

  .workbench__presentation {
    display: grid;
    grid-template-columns: 1.5rem 1fr;
    column-gap: 0.5rem;
  }

  .workbench__tools {
    ${mediaQuery.md`
      display: flex;
      flex-wrap: wrap;
    `}
  }

  .workbench__title {
    font-weight: 500;
    font-size: 1rem;
    margin: 0 0 0.75rem;
  }

  .workbench__description {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: #42526e;
  }

  .workbench__icon {
    height: 1.5rem;
  }

  .product-card {
    ${mediaQuery.md`
      margin-left: 2rem
    `}

    &__wrap {
      display: flex;
      justify-content: space-between;
      height: 100%;
    }

    &__icon {
      transform: rotate(-90deg);
      width: 0.5rem;
      margin-right: 1.5rem;
    }

    h2 {
      font-weight: 500;
    }
  }
`;

type WorkbenchDetailProps = {
  id: number;
  name?: string;
  description?: string;
  slug: string;
  tools: any;
  language: string;
  localized_texts: {
    description: { [key: string]: string };
  };
  onProductClick: Function;
};

const WorkbenchDetail = ({
  name,
  description,
  language,
  tools,
  onProductClick,
  localized_texts,
  slug,
}: WorkbenchDetailProps) => {
  const activeTools = tools.filter((tool: any) => tool.active);

  return (
    <WorkbenchDetailStyled>
      <div className="workbench__presentation">
        <div className="workbench__image">
          {slug === 'branding' && (
            <embed
              className="workbench__icon"
              src={brandingIcon}
              type="image/svg+xml"
            />
          )}
          {slug === 'innovation' && (
            <embed
              className="workbench__icon"
              src={innovationIcon}
              type="image/svg+xml"
            />
          )}
          {slug === 'experience' && (
            <embed
              className="workbench__icon"
              src={experienceIcon}
              type="image/svg+xml"
            />
          )}
        </div>
        <div className="workbench__info">
          <h3 className="workbench__title">{name}</h3>
          {localized_texts.description && language && (
            <p className="workbench__description">
              {language in localized_texts.description
                ? localized_texts.description[language]
                : description}
            </p>
          )}
        </div>
      </div>
      <div className="workbench__tools">
        <ProductsCards
          products={activeTools}
          onClick={(slug) => onProductClick(slug)}
          language={language}
        />
      </div>
    </WorkbenchDetailStyled>
  );
};

export default WorkbenchDetail;
